import { TeamMember } from "./teamMember";

export class Team {
    canManageTeam: boolean;
    teamMembers: TeamMember[];
    companyName?: string;
    companyUrl?: string;
    companyAddress1?: string;
    companyAddress2?: string;
    companyBackground?: string;
    companyLocationName?: string;
}
